export default {
  network: {
    'facebook': {
      url: 'http://www.facebook.com/sharer.php?u={url}&t={title}'
    },
    'facebook_dialog': {
      url: 'https://www.facebook.com/dialog/share?app_id={app_id}&display=page&href={url}&redirect_uri={redirect_url}'
    },
    'twitter': {
      // url: 'https://twitter.com/share?text={text}&url={url}'
      url: 'https://twitter.com/intent/tweet?hashtags={hashtags}&text={text}&url={url}&via={via}'

    },
    'reddit': {
      url: 'http://reddit.com/submit?url={url}&title={title}'
    }
  },
  generateSocialUrls (opt) {
    if (typeof opt !== 'object') {
      return false
    }
    let links = []
    let network
    for (let i = 0; i < this.Networks.length; i++) {
      network = this.Networks[i]
      links.push({
        name: network.name,
        class: network.class,
        url: this.generateUrl(network.url, opt)
      })
    }
    return links
  },
  generateUrl (url, opt) {
    let prop
    let arg
    let argNe

    for (prop in opt) {
      arg = '{' + prop + '}'
      if (url.indexOf(arg) !== -1) {
        url = url.replace(new RegExp(arg, 'g'), encodeURIComponent(opt[prop]))
      }
      argNe = '{' + prop + '-ne}'
      if (url.indexOf(argNe) !== -1) {
        url = url.replace(new RegExp(argNe, 'g'), opt[prop])
      }
    }
    return this.cleanUrl(url)
  },
  cleanUrl (fullUrl) {
    // firstly, remove any expressions we may have left in the url
    fullUrl = fullUrl.replace(/{([^{}]*)}/g, '')
    // then remove any empty parameters left in the url
    let params = fullUrl.match(/[^=&?]+=[^=&?]+/g)
    let url = fullUrl.split('?')[0]
    if (params && params.length > 0) {
      url += '?' + params.join('&')
    }
    return url
  },
  doPopup (e) {
    e = (e || window.event)
    let t = (e.target ? e.target : e.srcElement)

    // Case when <svg> is return instead of <a>
    t = t.href ? t : t.parentNode

    // Case when <path> is return instead of <svg>
    t = t.href ? t : t.parentNode

    let width = t.data - width || 800
    let height = t.data - height || 500
    // popup position
    let px = Math.floor(((screen.availWidth || 1024) - width) / 2)
    let py = Math.floor(((screen.availHeight || 700) - height) / 2)
    // open popup
    let popup = window.open(t.href, 'social',
      'width=' + width + ',height=' + height +
      ',left=' + px + ',top=' + py +
      ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1')
    if (popup) {
      popup.focus()
      if (e.preventDefault) e.preventDefault()
      e.returnValue = false
    }
    return !!popup
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/SocialShare.js
 **/